// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KHaIn8{position:absolute;bottom:0;display:inline-block;opacity:0;visibility:hidden;padding:6px;z-index:59}.tskI90{opacity:1;visibility:visible;z-index:59}.KoBNM_{opacity:0;visibility:hidden;z-index:58}.animated .KHaIn8{transition-property:left, right, top, bottom, opacity, visibility;transition-duration:1s}.lRYeN7{display:none;width:10px;height:10px;position:absolute;top:12px;right:12px;cursor:pointer;opacity:0.8}.lRYeN7:hover{opacity:0.6}.KHaIn8:hover .lRYeN7{display:block}[data-playable-hook="player-container"][min-width~="901px"] .lRYeN7{top:16px;right:16px}.preview-mode .lRYeN7{opacity:0.6;cursor:default}.preview-mode .lRYeN7:hover{opacity:0.6}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `KHaIn8`,
	"visible": `tskI90`,
	"hidden": `KoBNM_`,
	"close-button": `lRYeN7`,
	"closeButton": `lRYeN7`
};
export default ___CSS_LOADER_EXPORT___;
